import React from 'react';
import { AvForm, AvGroup, AvField } from 'availity-reactstrap-validation';
import { Row, Button } from 'reactstrap';
import MaterialIcon from 'material-icons-react';
import i18n from '../../i18next';

const PasswordVerificationScreen = props => {

    const { iconPadding, confirmButton } = styles;

    return (
        <AvForm onValidSubmit={props.onSubmit}>
            <Row style={{ marginLeft: 4 }}>
                <span>
                    <MaterialIcon icon="warning" color="#ffc107" size={20} />
                </span>
                <p style={{ margin: '4px 0px 20px 5px', fontSize: 14 }}>
                    {i18n.t('screens:posSettingsScreen.enterPasswordMsg')}
                </p>
            </Row>
            <AvGroup>
                <span className="spanEmailIcon"><MaterialIcon icon="lock" size={20} color="#a9a9a9" />
                    <AvField
                        style={iconPadding}
                        placeholder={i18n.t('common:form.password')}
                        type="password" name="userPassword" id="password" label={i18n.t('common:form.password')}
                        value={props.password}
                        onChange={props.onChange}
                        required
                        errorMessage={i18n.t('common:validations.errorMsg')}
                    />
                </span>
            </AvGroup>
            <Button style={confirmButton} color="primary" >
                {i18n.t('common:buttons.confirm')}
            </Button>
        </AvForm>
    );
}

export default PasswordVerificationScreen;

const styles = {
    iconPadding: {
        paddingLeft: 36,
        width: 286
    },
    confirmButton: {
        width: 286,
        marginBottom: 10
    }
}


// WEBPACK FOOTER //
// ./src/components/common/PasswordVerificationScreen.js